import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FetchDashboardService } from './../fetch-dashboard.service';
import { SaveEventDataService } from './../report/services/save-event-data.service';
import { ResendMailService } from './../report/services/resend-mail.service';
import { GetSellerInfoService } from './../report/services/get-seller-info.service';

import { SellerBankAccountsComponent } from './components/seller-bank-accounts/seller-bank-accounts.component';
import { SalesComponent } from './../report/components/sales/sales.component';
import { SettlementsComponent } from './components/settlements/settlements.component';
import { ProductsReportComponent } from './components/products-report/products-report.component';
import { TransactionsComponent } from './components/transactions/transactions.component';
import { AdvancedSalesComponent } from './components/advanced-sales/advanced-sales.component';
import { SellersComponent } from './components/sellers/sellers.component';
import { ReferralsComponent } from './components/referrals/referrals.component';
import { SellerStatementComponent } from './components/seller-statement/seller-statement.component';
import { IncomeReportComponent } from './components/income-report/income-report.component';
import { ErrorLoggerComponent } from './components/error-logger/error-logger.component';
import { DonationComponent } from './components/donation/donation.component';
import { SellerIncomeComponent } from './components/seller-income/seller-income.component';
import { TempTransactionsComponent } from './components/biller/temp-transactions/temp-transactions.component';

import { MatCardModule } from '@angular/material/card';
import { MerchantComponent } from './components/merchant/merchant.component';
import { GateSalesComponent } from './components/gate-sales/gate-sales.component';
import { GateCreditSalesComponent } from './components/gate-credit-sales/gate-credit-sales.component';
import { GateCashSalesComponent } from './components/gate-cash-sales/gate-cash-sales.component';
import { ProvidersReconciliationsComponent } from './components/providers-reconciliations/providers-reconciliations.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InvoiceAccountingReportComponent } from './components/invoice-accounting-report/invoice-accounting-report.component';
import { KYCReportComponent } from './components/kyc-report/kyc-report.component';
import { ViewKYCComponent } from './components/kyc-report/view-kyc/view-kyc.component';
import { BuyerUsersComponent } from './components/biller/buyerUsers/buyerUsersReport.component';
import { OtlobxReportComponent } from './components/otlobx-report/otlobx-report.component';
import { SalesFollowupComponent } from './../report/components/sales-followup/sales-followup.component';
import { SalesReportService } from './components/sales/sales-report.service';
import { SalesFollowUpReportService } from './components/sales-followup/sales-followup-report.service';
const reportRoutes: Routes = [
  { path: 'sales', component: SalesComponent },
  { path: 'salesFollowUp', component: SalesFollowupComponent },
  { path: 'sellerBankAccounts', component: SellerBankAccountsComponent },
  { path: 'settlements', component: SettlementsComponent },
  { path: 'products', component: ProductsReportComponent },
  { path: 'transactions', component: TransactionsComponent },
  { path: 'advanced-sales-report', component: AdvancedSalesComponent },
  { path: 'sellers', component: SellersComponent },
  { path: 'referrals', component: ReferralsComponent },
  { path: 'merchant', component: MerchantComponent },
  { path: 'sellerStatement', component: SellerStatementComponent },
  { path: 'income', component: IncomeReportComponent },
  { path: 'errorslogger', component: ErrorLoggerComponent },
  { path: 'donation', component: DonationComponent },
  { path: 'sellerIncome', component: SellerIncomeComponent },
  { path: 'gate-sales', component: GateSalesComponent },
  { path: 'credit-gate-sales', component: GateCreditSalesComponent },
  { path: 'cash-gate-sales', component: GateCashSalesComponent },
  {
    path: 'providers-reconciliations',
    component: ProvidersReconciliationsComponent,
  },

  {
    path: 'invoice-accounting-report',
    component: InvoiceAccountingReportComponent,
  },
  {
    path: 'kyc-report',
    component: KYCReportComponent,
  },
  {
    path: 'kyc-report/:id',
    component: ViewKYCComponent,
  },
  {
    path: 'biller',
    children: [
      { path: 'temp-transactions', component: TempTransactionsComponent },
      { path: 'billingUsersReport', component: BuyerUsersComponent },
    ],
  },
  {
    path: 'otlobx',
    children: [{ path: 'post-report', component: OtlobxReportComponent }],
  },
];

@NgModule({
  declarations: [
    SalesComponent,
    SellerBankAccountsComponent,
    SettlementsComponent,
    ProductsReportComponent,
    TransactionsComponent,
    AdvancedSalesComponent,
    SellersComponent,
    ReferralsComponent,
    SellerStatementComponent,
    IncomeReportComponent,
    ErrorLoggerComponent,
    DonationComponent,
    SellerIncomeComponent,
    MerchantComponent,
    GateSalesComponent,
    GateCreditSalesComponent,
    GateCashSalesComponent,
    ProvidersReconciliationsComponent,
    InvoiceAccountingReportComponent,
    TempTransactionsComponent,
    BuyerUsersComponent,
    KYCReportComponent,
    ViewKYCComponent,
    OtlobxReportComponent,
    SalesFollowupComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(reportRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatCardModule,
  ],
  providers: [
    FetchDashboardService,
    SaveEventDataService,
    ResendMailService,
    GetSellerInfoService,
    SalesReportService,
    SalesFollowUpReportService,
  ],
  exports: [ProductsReportComponent],
})
export class ReportModule {}
